import { render } from "./MarketingFooter.vue?vue&type=template&id=8f01394a"
import script from "./MarketingFooter.vue?vue&type=script&lang=js"
export * from "./MarketingFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__